/**
 * Check current set layout for web app
 * @param {"default" | "latam" | "US"} layout - layout to check
 */
export function checkLayout(layout) {
  return APP_SETTINGS.settings.layout === layout;
}